import { useMutation } from 'react-query';
import { getProductReservationApi } from '../../../../config/SwaggerProductReservationApi';

const deleteDGManagement = (id: string) =>
    getProductReservationApi()
        .deelproject.deleteDelete(id)
        .then((response) => response.data);

const useDeleteDGManagement = () => {
    const useDeleteDGManagementMutation = useMutation(deleteDGManagement);

    return useDeleteDGManagementMutation;
};

export default useDeleteDGManagement;
